import * as React from "react";

const QuizButton = ({ quizUrl }: { quizUrl: string }) => (
  <a
    className="finish-card-button"
    href={quizUrl}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Take the quiz now"
  >
    <span className="finish-card-quiz-text" data-url={quizUrl}>
      Take the quiz now
    </span>
  </a>
);

export default React.memo(QuizButton);
